import React from 'react';
import { useTranslation } from 'react-i18next';
import { getNumberWithTierSuffix } from 'utils/stringUtils';
import { RoiWorkspaceMetric } from '../types';
import RankedBarList from './RankedBarList';

interface Props {
  workspaces: RoiWorkspaceMetric[];
}

const RequestsByWorkspacePanel: React.FC<Props> = ({ workspaces }) => {
  const { t } = useTranslation('admin');

  const items = workspaces.map(w => ({
    label: w.workspaceName,
    value: w.totalRequests,
    displayValue: getNumberWithTierSuffix(w.totalRequests),
  }));

  return (
    <div className="roi-panel">
      <h3 className="roi-panel-title">{t('roiInsights.panels.requestsByWorkspace')}</h3>
      {items.length === 0 ? (
        <div className="roi-panel-empty">{t('roiInsights.noData')}</div>
      ) : (
        <RankedBarList items={items} barColor="#a78bfa" />
      )}
    </div>
  );
};

export default RequestsByWorkspacePanel;
